import React, { useMemo } from 'react';

import Button from 'pencil/Button';

const LanguageSwitcher = (props) => {
  const { locale: selectedLocale, selectLocale, locales } = props;

  return (
    <div>
      {locales.map((locale) => (
        <Button
          size="small"
          disabled={locale.key === selectedLocale.key || locale.disabled === true}
          key={locale.key}
          onClick={() => {
            selectLocale(locale.key);
            location.reload();
          }}
        >
          {locale.name}
        </Button>
      ))}
    </div>
  );
};

export default LanguageSwitcher;
